import { useEffect, useRef } from "react";
import { useAppDispatch } from "./useAppDispatch";
import { socketActions } from "src/store/actions";

export const useConnect = () => {
  const dispatch = useAppDispatch();

  const mountRef = useRef(false);

  useEffect(() => {
    if (!mountRef.current) {
      mountRef.current = true;

      dispatch(socketActions.connect());
    }
  }, [dispatch]);
};
